import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Leg } from '@approot/models/leg';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';
import { TradesService } from '@approot/services/trades/trades.service';
import { DateUtilities } from '@approot/utilities';
@Component({
  selector: 'app-save-trade',
  templateUrl: './save-trade.component.html',
  styleUrls: ['./save-trade.component.scss']
})
export class SaveTradeComponent implements OnInit {
  @Input() isModalOpened = false;
  @Input() legForm: FormGroup;
  @Input() leg: Leg;
  @Output() saveTradeOpenChanged = new EventEmitter<boolean>();
  @Output() tradeSaved = new EventEmitter<any>();
  attribute: any[] = []; // attribute that is needed for the selector
  saving: boolean; // if true, status message will be shown
  form: FormGroup;
  //savingInfo: string; // holds the message that will be shown

  constructor(
    private fb: FormBuilder,
    private tradesService: TradesService,
    private productsConfigService: ProductsConfigService
  ) {
    this.form = this.fb.group({
      client: this.fb.control('', [Validators.required]),
      tradeId: this.fb.control('', [Validators.required]),
      tradeDate: this.fb.control('', [
        Validators.required,
        this.dateControlValidator.bind(this)
      ]),
      counterParty: this.fb.control(''),
      premium: this.fb.control(''),
      premiumPaymentDate: this.fb.control('', [
        this.dateControlValidator.bind(this)
      ]),
      premiumCurrency: this.fb.control(''),
      premiumPayer: this.fb.control(''),
      status: this.fb.control('')
    });
  }

  ngOnInit() {
    if (this.legForm.get('cross')) {
      this.legForm.get('cross').valueChanges.subscribe(() => {
        // if the cross changes then we need
        this.form.get('premiumCurrency').setValue('');
        this.attribute = this.splitCross();
      });
    }

    if (this.form.get('tradeDate')) {
      this.form.get('tradeDate').valueChanges.subscribe(() => {
        // if the date changes makes it pretty
        this.localDateChanged(this.form.get('tradeDate'));
      });
    }
    if (this.form.get('premiumPaymentDate')) {
      this.form.get('premiumPaymentDate').valueChanges.subscribe(() => {
        this.localDateChanged(this.form.get('premiumPaymentDate'));
      });
    }
  }

  get savingInfo(): string {
    return this.tradesService.savingInfo;
  }

  localDateChanged(formElem: AbstractControl) {
    if (formElem.value && formElem.valid) {
      if (DateUtilities.isDateOfDashedFormat(formElem.value)) {
        let newDate = DateUtilities.dateToPrettyDate(formElem.value);
        this.patchDate(formElem, newDate);
      } else {
        DateUtilities.onDateChanged(formElem);
      }
    }
  }

  patchDate(formElem: AbstractControl, newDate: string) {
    setTimeout(() => {
      formElem.patchValue(newDate, {
        emitEvent: false
      });
    }, 5);
  }

  dateControlValidator(control: FormControl) {
    if (
      !control.value ||
      DateUtilities.isCorrectFullDateFormat(control.value)
    ) {
      return null;
    }
    return { invalidEntry: { value: control.value } };
  }

  onSubmit() {
    this.onTradeSaved();
  }

  formatDate(date: string) {
    return DateUtilities.getDateInISOFormat(date);
  }

  onTradeSaved() {
    let tempForm = this.form.value;
    tempForm['tradeDate'] = this.formatDate(tempForm['tradeDate']);
    tempForm['premiumPaymentDate'] = tempForm['premiumPaymentDate'] // turn these into dashed dates
      ? this.formatDate(tempForm['premiumPaymentDate'])
      : '';

    let product = {
      ...this.productsConfigService.productFormatter(
        this.legForm.value,
        this.leg.attributes
      ),
      ...tempForm
    };

    if (this.leg.productType === 'newdcd' && product.margin !== undefined) {
      // if the product is a newdcd remove the margin
      product.margin = '';
    }

    this.tradesService.saveTrade(product);
  }

  close() {
    this.modalChanged(false);
  }

  splitCross(): string[] {
    // split the cross into an array of two currencies
    return this.legForm.value.cross
      ? this.legForm.value.cross.match(/.{3}|.{1,2}/g)
      : [];
  }

  modalChanged(event) {
    this.saveTradeOpenChanged.emit(event);
  }
}
